import {
    SOCIETY_GET_VENDOR_CATEGORIES,
    SOCIETY_CREATE_VENDOR,
    SOCIETY_GET_VENDOR_DETAILS,
    SOCIETY_GET_VENDORS_LIST,
    SOCIETY_UPDATE_VENDOR,
    SOCIETY_DELETE_VENDOR,
    SOCIETY_GET_ALL_VENDORS,
    // Vendor Tariffs
    SOCIETY_GET_VENDOR_TARIFFS,
    SOCIETY_CREATE_VENDOR_TARIFF,
    SOCIETY_DELETE_VENDOR_TARIFF,
    SOCIETY_GET_ALL_VENDOR_TARIFFS,
    // Vendor Bills
    SOCIETY_GET_VENDOR_BILLS_LIST,
    SOCIETY_GET_VENDOR_BILL_DETAILS,
    SOCIETY_CREATE_VENDOR_BILL,
    SOCIETY_UPDATE_VENDOR_BILL,
    SOCIETY_DELETE_VENDOR_BILL,
    SOCIETY_APPROVE_VENDOR_BILL,
    SOCIETY_PAY_VENDOR_BILL,
    // Vendor Setting
    SOCIETY_GET_VENDOR_SETTING,
    // Vendor Category
    SOCIETY_CREATE_VENDOR_CATEGORY,
    SOCIETY_UPDATE_VENDOR_CATEGORY,
    SOCIETY_DELETE_VENDOR_CATEGORY,
    // Vendor Bank Accounts
    SOCIETY_GET_VENDOR_BANK_ACCOUNTS,
    SOCIETY_CREATE_VENDOR_BANK_ACCOUNT,
    SOCIETY_UPDATE_VENDOR_BANK_ACCOUNT,
    SOCIETY_DELETE_VENDOR_BANK_ACCOUNT,
    // Vendor AMC Tracker
    SOCIETY_GET_VENDOR_AMC_LIST,
    SOCIETY_GET_VENDOR_AMC_DETAILS,
    SOCIETY_CREATE_VENDOR_AMC,
    SOCIETY_UPDATE_VENDOR_AMC,
    SOCIETY_DELETE_VENDOR_AMC,
    // Vendor GL Codes
    SOCIETY_GET_VENDOR_GL_CODES,
    SOCIETY_GET_VENDOR_GL_CODE_DROPDOWN,
    // Vendor Round Off GL Code
    SOCIETY_GET_VENDOR_ROUND_OFF_GL,
    // Vendor Billing Settings
    SOCIETY_SAVE_VENDOR_BILLING_SETTINGS,
    SOCIETY_GET_VENDOR_BILLING_SETTINGS,
    SOCIETY_GET_VENDORS_DROPDOWN,
    // Vendor Payments
    SOCIETY_GET_VENDOR_PAYMENTS_LIST,
    SOCIETY_GET_VENDOR_PAYMENT_DETAILS,
    SOCIETY_CREATE_VENDOR_PAYMENT,
    SOCIETY_UPDATE_VENDOR_PAYMENT,
    SOCIETY_DELETE_VENDOR_PAYMENT,
    SOCIETY_GET_VENDOR_UNPAID_BILLS,
    // Bulk upload
    SOCIETY_BULK_UPLOAD_VENDORS,
    SOCIETY_BULK_UPLOAD_VENDORS_RESET,
    SOCIETY_BULK_UPLOAD_VENDOR_BILLS,
    SOCIETY_BULK_UPLOAD_VENDOR_BILLS_RESET,
    SOCIETY_BULK_UPLOAD_VENDOR_PAYMENTS,
    SOCIETY_BULK_UPLOAD_VENDOR_PAYMENTS_RESET,
    SOCIETY_CREATE_VENDOR_BILLS_BATCH,
    SOCIETY_CREATE_VENDOR_BILLS_BATCH_RESET,
} from '../../index.types';

export function getVendorCategories() {
    return {
        type: SOCIETY_GET_VENDOR_CATEGORIES
    }
}

export function createVendor(data) {
    return {
        type: SOCIETY_CREATE_VENDOR,
        data
    }
}

export function getVendorDetails(data) {
    return {
        type: SOCIETY_GET_VENDOR_DETAILS,
        data
    }
}

export function getVendorsList(data) {
    return {
        type: SOCIETY_GET_VENDORS_LIST,
        data
    }
}

export function updateVendor(data) {
    return {
        type: SOCIETY_UPDATE_VENDOR,
        data
    }
}

export function deleteVendor(data) {
    return {
        type: SOCIETY_DELETE_VENDOR,
        data
    }
}

export function getAllVendors(data) {
    return {
        type: SOCIETY_GET_ALL_VENDORS,
        data
    }
}

// ============ VENDOR SETTING ============

export function getVendorSetting(data) {
    return {
        type: SOCIETY_GET_VENDOR_SETTING,
        data
    }
}

export function createVendorCategory(data) {
    return {
        type: SOCIETY_CREATE_VENDOR_CATEGORY,
        data
    }
}

export function updateVendorCategory(data) {
    return {
        type: SOCIETY_UPDATE_VENDOR_CATEGORY,
        data
    }
}

export function deleteVendorCategory(data) {
    return {
        type: SOCIETY_DELETE_VENDOR_CATEGORY,
        data
    }
}

// ============ VENDOR TARIFFS ============

export function getVendorTariffs(data) {
    return {
        type: SOCIETY_GET_VENDOR_TARIFFS,
        data
    }
}

export function createVendorTariff(data) {
    return {
        type: SOCIETY_CREATE_VENDOR_TARIFF,
        data
    }
}

export function deleteVendorTariff(data) {
    return {
        type: SOCIETY_DELETE_VENDOR_TARIFF,
        data
    }
}

export function getAllVendorTariffs(data) {
    return {
        type: SOCIETY_GET_ALL_VENDOR_TARIFFS,
        data
    }
}

// ============ VENDOR BILLS ============

export function getVendorBillsList(data) {
    return {
        type: SOCIETY_GET_VENDOR_BILLS_LIST,
        data
    }
}

export function getVendorBillDetails(data) {
    return {
        type: SOCIETY_GET_VENDOR_BILL_DETAILS,
        data
    }
}

export function createVendorBill(data) {
    return {
        type: SOCIETY_CREATE_VENDOR_BILL,
        data
    }
}

export function createVendorBillsBatch(data) {
    return { type: SOCIETY_CREATE_VENDOR_BILLS_BATCH, data };
}

export function resetVendorBillsBatch() {
    return { type: SOCIETY_CREATE_VENDOR_BILLS_BATCH_RESET };
}

export function updateVendorBill(data) {
    return {
        type: SOCIETY_UPDATE_VENDOR_BILL,
        data
    }
}

export function deleteVendorBill(data) {
    return {
        type: SOCIETY_DELETE_VENDOR_BILL,
        data
    }
}

export function approveVendorBill(data) {
    return {
        type: SOCIETY_APPROVE_VENDOR_BILL,
        data
    }
}

export function payVendorBill(data) {
    return {
        type: SOCIETY_PAY_VENDOR_BILL,
        data
    }
}

// ============ VENDOR BANK ACCOUNTS ============

export function getVendorBankAccounts(data) {
    return {
        type: SOCIETY_GET_VENDOR_BANK_ACCOUNTS,
        data
    }
}

export function createVendorBankAccount(data) {
    return {
        type: SOCIETY_CREATE_VENDOR_BANK_ACCOUNT,
        data
    }
}

export function updateVendorBankAccount(data) {
    return {
        type: SOCIETY_UPDATE_VENDOR_BANK_ACCOUNT,
        data
    }
}

export function deleteVendorBankAccount(data) {
    return {
        type: SOCIETY_DELETE_VENDOR_BANK_ACCOUNT,
        data
    }
}

// ============ VENDOR AMC TRACKER ============

export function getVendorAmcList(data) {
    return {
        type: SOCIETY_GET_VENDOR_AMC_LIST,
        data
    }
}

export function getVendorAmcDetails(data) {
    return {
        type: SOCIETY_GET_VENDOR_AMC_DETAILS,
        data
    }
}

export function createVendorAmc(data) {
    return {
        type: SOCIETY_CREATE_VENDOR_AMC,
        data
    }
}

export function updateVendorAmc(data) {
    return {
        type: SOCIETY_UPDATE_VENDOR_AMC,
        data
    }
}

export function deleteVendorAmc(data) {
    return {
        type: SOCIETY_DELETE_VENDOR_AMC,
        data
    }
}

// ============ VENDOR GL CODES ============

export function getVendorGlCodes(data) {
    return {
        type: SOCIETY_GET_VENDOR_GL_CODES,
        data
    }
}

export function getVendorGlCodeDropdown(data) {
    return {
        type: SOCIETY_GET_VENDOR_GL_CODE_DROPDOWN,
        data
    }
}

// ============ VENDOR ROUND OFF GL CODE ============

export function getVendorRoundOffGl(data) {
    return {
        type: SOCIETY_GET_VENDOR_ROUND_OFF_GL,
        data
    }
}

// ============ VENDOR BILLING SETTINGS ============

export function saveVendorBillingSettings(data) {
    return {
        type: SOCIETY_SAVE_VENDOR_BILLING_SETTINGS,
        data
    }
}

export function getVendorBillingSettings(data) {
    return {
        type: SOCIETY_GET_VENDOR_BILLING_SETTINGS,
        data
    }
}

export function getVendorsDropdown(data) {
    return {
        type: SOCIETY_GET_VENDORS_DROPDOWN,
        data
    }
}

// ============ VENDOR PAYMENTS ============

export function getVendorPaymentsList(data) {
    return {
        type: SOCIETY_GET_VENDOR_PAYMENTS_LIST,
        data
    }
}

export function getVendorPaymentDetails(data) {
    return {
        type: SOCIETY_GET_VENDOR_PAYMENT_DETAILS,
        data
    }
}

export function createVendorPayment(data) {
    return {
        type: SOCIETY_CREATE_VENDOR_PAYMENT,
        data
    }
}

export function updateVendorPayment(data) {
    return {
        type: SOCIETY_UPDATE_VENDOR_PAYMENT,
        data
    }
}

export function deleteVendorPayment(data) {
    return {
        type: SOCIETY_DELETE_VENDOR_PAYMENT,
        data
    }
}

export function getVendorUnpaidBills(data) {
    return {
        type: SOCIETY_GET_VENDOR_UNPAID_BILLS,
        data
    }
}

// ============ VENDOR BULK EXCEL UPLOAD ============

// data: { file: File, societyId, onSuccess?, onError? }
export function bulkUploadVendors(data) {
    return {
        type: SOCIETY_BULK_UPLOAD_VENDORS,
        data
    };
}

// Dispatched after the results modal is dismissed so the next upload starts
// with a clean summary.
export function resetVendorBulkUpload() {
    return { type: SOCIETY_BULK_UPLOAD_VENDORS_RESET };
}

// data: { file: File, societyId, onSuccess?, onError? }
export function bulkUploadVendorBills(data) {
    return { type: SOCIETY_BULK_UPLOAD_VENDOR_BILLS, data };
}

export function resetVendorBillBulkUpload() {
    return { type: SOCIETY_BULK_UPLOAD_VENDOR_BILLS_RESET };
}

// data: { file: File, societyId, onSuccess?, onError? }
export function bulkUploadVendorPayments(data) {
    return { type: SOCIETY_BULK_UPLOAD_VENDOR_PAYMENTS, data };
}

export function resetVendorPaymentBulkUpload() {
    return { type: SOCIETY_BULK_UPLOAD_VENDOR_PAYMENTS_RESET };
}
